export interface MailerData {
  email: string
  group: string
  fields?: {
    name?: string
    lastName?: string
    phone?: string
    company?: string
    referrer?: string
  }
}

export interface MailerGroupData {
  email: string
  group: string
}

// CLIENT SIDE FUNCTION
export const subscribe = async (data: MailerData) => {
  return fetch('/api/mail/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      status: 'active',
      ...data,
    }),
  }).then((response) => response.json())
}

// SERVERLESS FUNCTION
export const addToGroup = async (data: MailerGroupData) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('not adding to mailerlite in dev')
    return
  }

  const apiKey = process.env.MAILERLITE_API_KEY

  const groups_endpoint = `https://api.mailerlite.com/api/v2/groups/${data.group}/subscribers`

  const response = await fetch(groups_endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-MailerLite-ApiKey': apiKey || '',
    },
    body: JSON.stringify({
      email: data.email,
    }),
  })

  // Check if response status is 204 (No Content) or if response has no content
  if (
    response.status === 204 ||
    response.headers.get('content-length') === '0'
  ) {
    return { success: true }
  }

  try {
    const json = await response.json()

    if (json.error) {
      throw new Error(json.error)
    }

    return json
  } catch (error) {
    if (response.ok) {
      // If response was successful but JSON parsing failed, consider it a success
      return { success: true }
    }
    throw error
  }
}

// SERVERLESS FUNCTION
export const removeFromGroup = async (data: MailerGroupData) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('not removing from mailerlite in dev')
    return
  }

  const apiKey = process.env.MAILERLITE_API_KEY

  const groups_endpoint = `https://api.mailerlite.com/api/v2/groups/${data.group}/subscribers/${data.email}`

  const response = await fetch(groups_endpoint, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-MailerLite-ApiKey': apiKey || '',
    },
  })

  // Check if response status is 204 (No Content) or if response has no content
  if (
    response.status === 204 ||
    response.headers.get('content-length') === '0'
  ) {
    return { success: true }
  }

  try {
    const json = await response.json()

    if (json.error) {
      throw new Error(json.error)
    }

    return json
  } catch (error) {
    if (response.ok) {
      // If response was successful but JSON parsing failed, consider it a success
      return { success: true }
    }
    throw error
  }
}
